/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-27T10:46:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-06T20:36:32+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control, Errors} from 'react-redux-form/src';
import MLabelInput from './../components/MLabelInput';
import AErrorInput from './../components/AErrorInput';
import MErrorGroupInput from './../components/MErrorGroupInput';
import OInputDate from './../components/OInputDate';
import shouldShowErrors from './shouldShowErrors';
import {
  createDateMask,
  createDateParser,
  createDateFormatter,
} from './../masks/dateMask';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form/src';


/**
 * OInputFieldDate - …
**/
class OInputFieldDate extends Component {
  constructor(props) {
    super(props);

    this.setMaskFunctions(props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dateFormat !== this.props.dateFormat) {
      this.setMaskFunctions(nextProps);
    }
  }

  render() {
    const {
      model,
      defaultValue,
      disabled,
      placeholder,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      maxDate,
      minDate,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      onChange,
      setTouched,
    } = this.props;

    return (
      <div className="o-input-field o-input-field-date">
        <MLabelInput
          htmlFor={model}
          label={label}
          description={description}
          toolLabel={toolLabel}
          toolIcon={toolIcon}
          onPressTool={onPressTool}
          disabled={disabled}
        />
        <Control.text
          model={model}
          defaultValue={(typeof defaultValue === 'object') ? this.formatter(defaultValue) : undefined}
          component={OInputDate}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          disabled={disabled}
          withFieldValue={true}
          parser={this.parser}
          controlProps={{
            id: model,
            disabled,
            placeholder,
            maxDate,
            minDate,
            parser: this.parser,
            mask: this.mask,
            formatter: this.formatter,
            startWithYears: this.props.startWithYears,
            pickerFallbackDate: this.props.pickerFallbackDate,
          }}
          mapProps={{
            error: (props) => shouldShowErrors(showErrors, props),
            value: (props) => {
              // if modelValue is a Date, we format it properly
              if (props.modelValue instanceof Date) {
                return this.formatter(props.modelValue);
              }

              // we let the input uncontrolled when we do not get a date value
              // to prevent the whole input to be deleted we do not return
              // a value so the input is uncontrolled till modelValue has an valid value
              return undefined;
            },
            onChange: (props) => { // eslint-disable-line arrow-body-style
              return (event, value) => {
                if (props.onChange) {
                  props.onChange(value); // the string date value
                }
                if (onChange) {
                  onChange();
                }
                setTouched(model);
              };
            },
          }}
        />
        <Errors
          model={model}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }

  setMaskFunctions(props = this.props) {
    const {dateFormat} = props;

    this.mask = createDateMask({dateFormat});
    this.parser = createDateParser({dateFormat});
    this.formatter = createDateFormatter({dateFormat});
  }
}
OInputFieldDate.propTypes = {
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  model: PropTypes.string.isRequired,
  /**
     * a date format
     * accepts exactly one M for month, one D for days and
     * one Y for years: 'D/M/Y' or 'D.M.Y'
     */
  dateFormat: PropTypes.string.isRequired,
  /**
     * default value of the component
     */
  defaultValue: PropTypes.instanceOf(Date),
  /**
     * disable the input
     */
  disabled: PropTypes.bool,
  /**
     * placeholder for input
     */
  placeholder: PropTypes.string,
  /**
     * hash with validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validators: PropTypes.object,
  /**
     * when validation should be fired
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
     * hash with async validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  asyncValidators: PropTypes.object,
  /**
     * error messages for validatiors
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  messages: PropTypes.object,
  /**
     * when errors should be shown
     * function which gets passed the props of the form-model
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
     * max date for the date-picker
     * it isn't a garantee that the user doesn't type a date which
     * is outside the range – this should be part of a validation function
     */
  maxDate: PropTypes.object,
  /**
     * min date for the date-picker
     * it isn't a garantee that the user doesn't type a date which
     * is outside the range – this should be part of a validation function
     */
  minDate: PropTypes.object,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,
};
OInputFieldDate.defaultProps = {
  validateOn: 'change',
  dateFormat: 'D.M.Y',
};

/**
 * called from react-redux connect() on a redux store update
 * enables component to send actions via dispatch() to react-redux
 *
 * @param {function} dispatch
 * @param {object} ownProps
 * @return {object}
 */
function mapDispatchToProps(dispatch, ownProps) {
  return {
    setTouched: (model) => {
      dispatch(actions.setTouched(model));
    },
  };
}


export default connect(null, mapDispatchToProps)(OInputFieldDate);

